module.exports = __webpack_public_path__ + "static/media/galen@3x.2da0bde5.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/team/galen@3x.png
// module id = 216
// module chunks = 1